import CreateInvestmentError from './CreateInvestmentError';
class InvalidTokenCode extends CreateInvestmentError {
    constructor(options) {
        super('The provided token is not valid', options);
    }
}
export default InvalidTokenCode;
